import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/site-pack";

// Hoisted out of the component: a config literal is a new object every render,
// and the form's provider rebuilds its widget tree when that identity changes —
// which detaches the control being typed into. See the note in ../pack/edit.
//
// Three fields and no archive. The bundle is attached on the edit screen,
// because the file has to be uploaded to Documents and extracted by bucketws
// before it can be picked, and a create dialog demanding one cannot be
// completed by somebody who has not uploaded it yet.
const CREATE_FIELDS = {
  "/Public/SitePack/Create": {
    fields: [
      "packId",
      "route",
      "type",
    ],
  },
};

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({
  history,
  match: {
    params: { siteId },
  },
}) => {
  const { base } = useSectionContext();
  // `type` is seeded with the schema's own default rather than left empty. An
  // enum select with a "" default SHOWS its first option while the form holds
  // nothing, so a person who agrees with what they see picks nothing, fires no
  // change event, and submits a value the schema then rejects.
  const initial = {
    packId: "",
    route: "/",
    type: "spa",
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/SitePack/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update({})}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { siteId, input } });
      }}
      onCompleted={(data) => {
        // `data` directly, not `{ data }` — Section's Mutation forwards
        // Apollo's onCompleted argument as-is. See the long note in
        // ../../sections/new.
        //
        // Straight into the editor, because a pack created here has nothing to
        // serve yet: attaching the archive is the next click every time, and
        // the list would show a PENDING row whose only useful action is the one
        // this skips to.
        const created = data && data.viewer.account.sites.get.packs.create;

        history.replace(created ? `${base}/${created.packId}/edit` : base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: CREATE_FIELDS,
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
